import React from "react";
import { useTranslation } from "react-i18next";

const Newsletter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="newsletter" className="banner neumorphic-container rounded-0 p-5 mb-0">
      <div className="neumorphic-container rounded-5 p-5 mb-0 col-lg-10 mx-auto">
        <div className="container col-lg-12 mb-5">
          <h2 className="text-center gradient-text w-100">{t("newsletter.title")}</h2>
          <h3 className="text-center">{t("newsletter.subtitle")}</h3>
          <p className="text-center col-lg-6 m-auto">{t("newsletter.description")}</p>
        </div>
        <form className="d-flex col-lg-6 col-sm-12 neumorphic-container rounded-5 m-auto p-2 justify-content-center"
              action="https://api.web3forms.com/submit" method="POST">
          <input type="hidden" name="access_key" value=""/>
          <input type="hidden" name="redirect" value="https://www.weso.com.mx/thank-you.html"/>
          <div className="col-lg-12 align-self-end row p-0">
            <label className="col-lg-8 col-sm-12 mb-lg-0 mb-2">
              <input className="contact-field form-control rounded-5 form-input-bg-none"
                     type="email" name="email" placeholder={t("newsletter.emailPlaceholder")} required/>
            </label>
            <button className="col-lg-4 col-sm-8 mb-lg-0 contact-button  rounded-5 button gradient" type="submit">{t("newsletter.submitButton")}</button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Newsletter;
